import { render, staticRenderFns } from "./selectResponsibleAndRole.vue?vue&type=template&id=5482f9c0"
import script from "./selectResponsibleAndRole.vue?vue&type=script&lang=js"
export * from "./selectResponsibleAndRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports